(function () {
  function embedUrl(card) {
    var params = new URLSearchParams({
      start: card.dataset.start || "0",
      end: card.dataset.end || "",
      rel: "0",
      modestbranding: "1",
      autoplay: "1"
    });
    return "https://www.youtube.com/embed/" + card.dataset.videoId + "?" + params.toString();
  }

  function watchUrl(card) {
    return "https://www.youtube.com/watch?v=" + card.dataset.videoId + "&t=" + (card.dataset.start || "0") + "s";
  }

  function init(section) {
    var modal = section.querySelector("[data-uvp-modal]");
    var frame = section.querySelector("[data-uvp-frame]");
    var title = section.querySelector("[data-uvp-modal-title]");
    var meta = section.querySelector("[data-uvp-modal-meta]");
    var summary = section.querySelector("[data-uvp-modal-summary]");
    var link = section.querySelector("[data-uvp-modal-link]");
    var cards = Array.prototype.slice.call(section.querySelectorAll("[data-uvp-card]"));

    function open(card) {
      frame.innerHTML =
        '<iframe src="' +
        embedUrl(card) +
        '" title="' +
        card.dataset.title +
        '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
      title.textContent = card.dataset.title;
      meta.textContent = card.dataset.model + " by " + card.dataset.creator;
      summary.textContent = card.dataset.videoIntro + " " + card.dataset.experience;
      link.href = watchUrl(card);
      modal.hidden = false;
      document.body.style.overflow = "hidden";
    }

    function close() {
      modal.hidden = true;
      frame.innerHTML = "";
      document.body.style.overflow = "";
    }

    section.querySelectorAll("[data-uvp-open]").forEach(function (button) {
      button.addEventListener("click", function () {
        open(button.closest("[data-uvp-card]"));
      });
    });

    section.querySelectorAll("[data-uvp-close]").forEach(function (button) {
      button.addEventListener("click", close);
    });

    section.querySelectorAll("[data-uvp-filter]").forEach(function (button) {
      button.addEventListener("click", function () {
        var model = button.dataset.uvpFilter;
        section.querySelectorAll("[data-uvp-filter]").forEach(function (tab) {
          tab.classList.remove("is-active");
        });
        button.classList.add("is-active");
        cards.forEach(function (card) {
          card.hidden = model !== "all" && card.dataset.model !== model;
        });
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !modal.hidden) close();
    });
  }

  document.querySelectorAll("[data-uvp-section]").forEach(init);
})();
